import {useMemo} from 'react';
import {Company} from '@legit.health/ui';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import {TFunction} from 'i18next';

export default function useSteps({t, company}: {t: TFunction; company: Company}) {
  return useMemo(
    () => [
      {
        label: t('shared/common:diagnosticReport.form.steps.two'),
        icon: <AccessibilityIcon />
      },
      ...(company.isForClinicalTrials
        ? []
        : [
            {
              label: t('shared/common:diagnosticReport.form.steps.one'),
              icon: <QuestionAnswerIcon />
            }
          ]),
      {
        label: t('shared/common:diagnosticReport.form.steps.three'),
        icon: <ImportContactsIcon />
      },
      {
        label: t('shared/common:diagnosticReport.form.steps.four'),
        icon: <AddAPhotoIcon />
      },
      {
        label: t('shared/common:diagnosticReport.form.steps.five'),
        icon: <AssignmentIcon />
      }
    ],
    [t, company.isForClinicalTrials]
  );
}
